import React from 'react';
import { Create, Loading, useGetList } from 'react-admin';
import ModuleInputs from './ModuleInputs';

const ModuleCreate = (props) => {
    const { data, isLoading, error } = useGetList('Status', {
        filter: { q: 'In Development' },
    });

    if (isLoading) {
        return <Loading />;
    }

    if (error) {
        console.log(`Error fetching the 'In Development' status : ${error}`);
    }

    let moduleDefaultValues = null;
    if (data && data.length > 0) {
        moduleDefaultValues = { statusId: data[0].id };
    }

    return (
        <Create {...props} redirect="edit">
            <ModuleInputs
                {...props}
                defaultValues={moduleDefaultValues}
                create={true}
            />
        </Create>
    );
};

export default ModuleCreate;
